import { TState } from '../common/types';

export const initialState: TState = {
  mediaItems: [],
  acceptedFiles: [],
  loading: false,
  progressingFiles: {},

  //exporting
  downloadURL: '',
  exportURL: '',
  exporting: false,

  importing: false,
  importURL: '',
  importId: '',

  error: '',
  isImportExportModalOpen: false,
};
